import { useState } from "react";
import emailjs from "emailjs-com";
import Swal from "sweetalert2"; // Importamos SweetAlert
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";

const initialState = {
  name: "",
  email: "",
  message: "",
};

export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name || !email || !message) {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "Por favor, complete todos los campos.",
      });
      return;
    }

    const templateParams = {
      to_name: "Lucas Martínez",
      from_name: name,
      from_email: email,
      message: message,
      reply_to: email,
    };

    emailjs
      .send("service_0tdctgd", "template_wm4y7en", templateParams, "DbKJmywyd747hXh6C")
      .then(
        (result) => {
          console.log("Mensaje enviado:", result.text);
          Swal.fire({
            icon: "success",
            title: "Mensaje enviado",
            text: "Nos pondremos en contacto contigo lo antes posible.",
            customClass: {
              popup: "large-swal",
            }
          });

          clearState(); // Limpiar el formulario
        },
        (error) => {
          console.log("Error al enviar:", error.text);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Hubo un problema al enviar el mensaje. Inténtalo nuevamente.",
            customClass: {
              popup: "large-swal",
            }
          });
        }
      );
  };

  return (
    <div>
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>Póngase en contacto</h2>
                <p>
                  Por favor, complete el formulario a continuación para enviarnos un correo electrónico y
                  nos pondremos en contacto con usted lo antes posible.
                </p>
              </div>

              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="Nombre"
                        required
                        value={name}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="Email"
                        required
                        value={email}
                        onChange={handleChange}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <textarea
                    name="message"
                    id="message"
                    className="form-control"
                    rows="4"
                    placeholder="Mensaje"
                    required
                    value={message}
                    onChange={handleChange}
                  ></textarea>
                  <p className="help-block text-danger"></p>
                </div>
                <div id="success"></div>
                <button type="submit" className="btn btn-custom btn-lg">
                  Enviar Mensaje
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contacto Información</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Dirección
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Teléfono
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href="https://www.instagram.com/syspartech/" target="_blank" rel="noopener noreferrer">
                      <FontAwesomeIcon icon={faInstagram} />
                    </a>
                    <div style={{ fontSize: "20px", marginBottom: "-30px" }}>Siguenos en Instagram</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; Copyright 2025 Desarrollado por Syspar Technologies
          </p>
        </div>
      </div>
    </div>
  );
};
